module.exports = __webpack_public_path__ + "9715029a4ce07dbc0bea0a0add3860b8.svg";